import { render } from "./OnboardingScreen.vue?vue&type=template&id=a359f45c&scoped=true"
import script from "./OnboardingScreen.vue?vue&type=script&lang=js"
export * from "./OnboardingScreen.vue?vue&type=script&lang=js"

import "./OnboardingScreen.vue?vue&type=style&index=0&id=a359f45c&lang=scss&scoped=true"
import "./OnboardingScreen.vue?vue&type=style&index=1&id=a359f45c&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a359f45c"]])

export default __exports__